import { values, compact, first } from 'lodash';

export function determineLocale() {
  const html = document.querySelector('html').getAttribute('lang');
  const intl = Intl.NumberFormat()?.resolvedOptions()?.locale;
  const htmlLegacy = document
    .querySelector('meta[http-equiv=content-language]')
    ?.getAttribute('content');
  const _navigator =
    navigator.languages && navigator.languages.length
      ? navigator.languages[0]
      : navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en-US';

  const possibleValues = {
    html,
    intl,
    htmlLegacy,
    navigator: _navigator,
  };

  return first(compact(values(possibleValues)));
}

export function getLanguage() {
  const locale = determineLocale();
  return locale.replace('_', '-').split('-')[0];
}

export function expandLocales(locale) {
  let locales = [locale];
  let i = locale.lastIndexOf('-');

  while (i > 0) {
    locale = locale.slice(0, i);
    locales.push(locale);
    i = locale.lastIndexOf('-');
  }

  return locales;
}
